import styled from "styled-components";
//
const Block = styled.div`
  background-color: rgb(255, 123, 0);
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const Circle = styled.div`
  background-color: white;
  border-radius: 50%;
  width: 220px;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Stars = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
`;

const Star = styled.i`
  color: gold;
  font-size: 20px;
  margin-right: 2px;
`;

const AvisClients = styled.div`
  background-color: #ffcc00;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
  color: black;
  margin-top: 5px;
`;

const InfoBox = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  span.number {
    font-size: 14px;
    display: block;
  }
`;

const DataBox = styled.div`
  text-align: center;
  font-size: 17px;
  font-weight: bold;
  max-width: 200px;
  margin-top: 10px;
  margin-bottom: 10px;

  color: white;

  span.number {
    font-size: 40px;
    margin-bottom: 10px;
    display: block;
    color: white;
  }
`;

const StatsBlock = () => {
  return (
    <Block style={{ marginTop: "7%" }}>
      <DataBox>
        <span className="number">126 </span>
        Professionnels formés <br /> chaque année
      </DataBox>
      <DataBox>
        <span className="number">96%</span>
        de taux de maintien,
        <br /> une garantie de qualité
      </DataBox>
      <Circle>
        <InfoBox>
          <span className="number">
            Taux de réussite aux formations, parmi les meilleurs
          </span>
        </InfoBox>
        <Stars>
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="fa fa-star" />
          ))}
        </Stars>
        <InfoBox>4,8/5</InfoBox>
        <AvisClients>28 567 Avis Clients</AvisClients>
      </Circle>
      <DataBox>
        <span className="number">9,5/10</span>
        Évaluation pédagogique
      </DataBox>
      <DataBox>
        <span className="number">38</span>
        entreprises et clients <br /> de confiance
      </DataBox>
    </Block>
  );
};

export default StatsBlock;
